const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20red%20carpet%20event%20photography%2C%20elegant%20glamorous%20atmosphere%2C%20warm%20spotlight%20lighting%2C%20paparazzi%20style%2C%20editorial%20magazine%20quality%2C%20luxurious%20golden%20and%20coral%20tones%2C%20dramatic%20shadows%2C%20high%20fashion%20editorial&width=1200&height=800&seq=carousel-01&orientation=landscape',
    tag: '深度专题',
    title: '2026娱乐圈半年盘点：十大最轰动的吃瓜事件',
    desc: '从顶流塌房到综艺翻车，从品牌解约到恋情实锤，回顾上半年那些让我们彻夜难眠的热门爆料。',
    alt: '911吃瓜网娱乐圈半年盘点专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20drama%20behind%20the%20scenes%20production%20set%2C%20warm%20cinematic%20lighting%2C%20film%20equipment%20and%20crew%20silhouettes%2C%20dramatic%20atmosphere%2C%20golden%20hour%20glow%2C%20professional%20filmmaking%20aesthetic%2C%20editorial%20photography&width=1200&height=800&seq=carousel-02&orientation=landscape',
    tag: '独家揭秘',
    title: '综艺节目幕后规则大起底：那些你不知道的录制真相',
    desc: '选秀节目真的有剧本吗？飞行嘉宾是怎么选出来的？带你走进综艺录制的真实世界。',
    alt: '911吃瓜网综艺节目幕后揭秘专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20with%20colorful%20stage%20lights%2C%20energetic%20concert%20atmosphere%2C%20warm%20amber%20and%20red%20lighting%2C%20dynamic%20crowd%20movement%2C%20festival%20vibes%2C%20editorial%20photography%20style&width=1200&height=800&seq=carousel-03&orientation=landscape',
    tag: '热点追踪',
    title: '音乐节频频出事：从票务争议到现场安全，谁来负责？',
    desc: '从天价票价到舞台事故，音乐节经济背后隐藏着哪些不为人知的故事与争议。',
    alt: '911吃瓜网音乐节热点追踪专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topics%20visualization%2C%20abstract%20digital%20art%20with%20warm%20tones%2C%20viral%20content%20concept%2C%20glowing%20notification%20elements%2C%20modern%20tech%20aesthetic%20with%20entertainment%20theme%2C%20editorial%20composition&width=1200&height=800&seq=carousel-04&orientation=landscape',
    tag: '行业观察',
    title: '直播电商大洗牌：头部主播频频翻车背后的行业真相',
    desc: '从千万粉丝到信任危机，直播带货行业正在经历一场前所未有的信任重构。',
    alt: '911吃瓜网直播电商行业观察专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <span className="text-xs text-foreground-400">深度原创内容</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-bold text-background-50 bg-primary-500/90 px-2 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-accent-700 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}